import {
  ActionType,
  IDeleteBusinessUserPayload,
  DeleteBusinessUserResponse,
} from "models/userListBusiness/deleteBusinessUser";

export const deleteBusinessUserAction = (
  payload: IDeleteBusinessUserPayload
) => {
  return {
    type: ActionType.DELETE_BUSINESS_USER,
    payload,
  };
};

export const handleErrorAction = (payload: string) => {
  return {
    type: ActionType.DELETE_BUSINESS_USER_ERROR,
    payload,
  };
};

export const handleSuccesAction = (payload: DeleteBusinessUserResponse) => {
  return {
    type: ActionType.DELETE_BUSINESS_USER_SUCCESS,
    payload,
  };
};

export const handleResetAction = () => {
  return {
    type: ActionType.DELETE_BUSINESS_USER_RESET,
  };
};
